import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCommentPwa = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={34} height={34} fill='none' {...props}>
    <rect width={34} height={34} fill='rgb(var(--blue-1))' rx={6} />
    <path
      stroke='#fff'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d='M14.375 22.25H14c-3 0-4.5-.75-4.5-4.5V14q0-4.5 4.5-4.5h6q4.5 0 4.5 4.5v3.75q0 4.5-4.5 4.5h-.375a.76.76 0 0 0-.6.3l-1.125 1.5c-.495.66-1.305.66-1.8 0l-1.125-1.5a.85.85 0 0 0-.6-.3'
    />
    <path
      stroke='#fff'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1.5}
      d='M13.25 14h7.5M13.25 17.75h4.5'
    />
  </svg>
);
export default SvgCommentPwa;
